import { render, staticRenderFns } from "./EfemeridesView.vue?vue&type=template&id=4c72b7f2&"
import script from "./EfemeridesView.vue?vue&type=script&lang=ts&"
export * from "./EfemeridesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports